import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NcformComponent } from './ncform/ncform.component';

const routes: Routes = [
  {
    path:'ncform',
    component:NcformComponent,

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PierhippncRoutingModule { }
